import { type PaletteDef, usePaletteTrigger } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { SidebarItemButton, Tooltip } from '@gitbook/spine-react';

// Should be in Spine, but we can't import from react-uikit
export function SidebarActionsButton(props: { palette: () => PaletteDef }) {
    const { palette } = props;
    const { triggerProps } = usePaletteTrigger<HTMLDivElement>({ palette });
    return (
        <Tooltip label="More actions">
            <SidebarItemButton icon={Icon.MoreVertical} {...triggerProps} />
        </Tooltip>
    );
}
